import {
	Component,
	Output,
	EventEmitter,
	Input,
	ViewChild,
	OnInit,
} from '@angular/core';
import {
	DepositHolder,
	MatterAdjustmentDepositRecordCalculated,
	MatterFields,
	DepositHolderSelections,
	MatterFieldMappings,
} from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AI_GENERATED_ICON, ICON } from '@core/util/icon';
import { SelectedMatter } from '@state/matter/matter.selectors';

import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { DepositDrawerComponent } from '../deposit-drawer/deposit-drawer.component';
import { NavigationService } from '@services/nav/nav.service';
import { ActivatedRoute } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';
import { TestHooks } from './sale-deposit-side-form.hooks';

export enum DepositSideFormMode {
	SIDE_FORM = 'sideForm',
	DRAWER = 'drawer',
}

@UntilDestroy()
@Component({
	selector: 'app-sale-deposit-side-form',
	templateUrl: './sale-deposit-side-form.component.html',
	standalone: false,
})
export class SaleDepositSideFormComponent implements OnInit {
	testHooks = TestHooks;
	@Output() onFocus = new EventEmitter<string>();

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(AdjustmentsSelector.depositAdjustmentCalculated)
	depositTotal$: Observable<MatterAdjustmentDepositRecordCalculated>;
	@Select(SelectedMatter.getSelectedDepositHolder)
	depositHolder$: Observable<DepositHolder>;
	@Select(SelectedMatter.getFieldMappings)
	fieldMappings$: Observable<MatterFieldMappings>;

	@ViewChild('depositDrawer') depositDrawer: DepositDrawerComponent;

	@Input() mode: DepositSideFormMode = DepositSideFormMode.SIDE_FORM;
	@Input() label: string;
	@Input() skeletonLoading = false;
	public field = MatterFields.DEPOSIT;
	public ICON = ICON;
	public AI_ICON = AI_GENERATED_ICON.icon;
	public AI_TOOLTIP = AI_GENERATED_ICON.tooltip;
	public AI_CLASSES = AI_GENERATED_ICON.classes;
	public depositSideFormMode = DepositSideFormMode;
	public depositHolderName$: Observable<string>;

	constructor(
		private navigationService: NavigationService,
		private route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.depositHolderName$ = this.depositHolder$.pipe(
			untilDestroyed(this),
			map((depositHolder) => {
				const depositHolderName = DepositHolderSelections.find(
					(x) => x.value === depositHolder,
				)?.name;
				return depositHolderName ?? '';
			}),
		);
	}

	openDepositDrawer() {
		this.depositDrawer.openDrawer();
	}

	openDepositModal() {
		this.navigationService.goToUrl('edit-deposits', null, {
			relativeTo: this.route,
		});
	}

	_onFocus() {
		this.onFocus.emit(this.field);
	}
}
